import { Component, OnInit, ViewChild } from '@angular/core';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { DashboardService } from './dashboard.service';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexFill,
  ApexPlotOptions,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexDataLabels,
  ApexTooltip,
  ApexLegend
} from "ng-apexcharts";

export type BarChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  fill: ApexFill;
  plotOptions: ApexPlotOptions;
};

export type DonutChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  tooltip: ApexTooltip;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
};

export type HBarChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};

export type MultipleRadialChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})

export class DashboardComponent implements OnInit {

  breadcrumbConfig: object = {
    lastLinkColor: '#5B616E',
    symbol: ' / ',
  };

  page = 1;
  rows = 5;
  countUser: any = 0;
  countclient: any = 0;
  countProject: any = 0;
  countRole: any = 0;
  countDepartment: any = 0;
  countDesignation: any = 0;
  countTechnology: any = 0;
  prData: any;
  chartOptions: any;
  PRCount: any;
  user_id: any;
  userName: any;
  userRole: any;
  job: any;
  jobid: any;
  ipipelineid: any;
  value = '';
  list: any = [];
  candidateByStageArray: any = [];
  series: any = [];
  candidateData: any = [];
  chartArray = [];
  labels: any = [];
  countData: any = [];
  prSeries: any = [];
  prCategories: any = [];

  @ViewChild("chart") chart: ChartComponent;

  constructor(
    private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    this.user_id = sessionStorage.getItem('id');
    this.userName = sessionStorage.getItem('firstName');
    this.validateUser();
    const breadcrumb = { customText: 'This is Custom Text', dynamicText: 'Level 2 ' };
    this.ngDynamicBreadcrumbService.updateBreadcrumbLabels(breadcrumb);
    this.listAllJobs();
    this.listUser();
    this.listClients();
    this.listProjects();
    this.listRole();
    this.listTechnology();
    this.listAllDesignation();
    this.listDepartments();
    this.countUsersByRole();
    this.PrOverview();
    setTimeout(() => {
      this.GetManagementOverview();
    }, 500);
  }

  barChartOptions: Partial<BarChartOptions> = {
    series: [
      {
        data: []
      }
    ],
    chart: {
      height: 550,
      type: "bar",
      toolbar: {
        show: true,
        tools: {
          download: false
        }
      },
    },
    xaxis: {
      labels: {
        rotate: -60,
        maxHeight: 205,
      },
      categories: []
    },
    plotOptions: {
      bar: {
        distributed: true
      }
    },
    fill: {
      colors: ['#2F6DAA', '#76E7A7', '#F8B932', '#EC5673', '#8A6FD7', '#3F829C', '#6D848E', '#D86683', '#6FDEB8', '#B2A69C']
    }
  };

  donutChartOptions: Partial<DonutChartOptions> = {
    series: [],
    chart: {
      type: "donut",
      height: 265,
      redrawOnWindowResize: false
    },
    labels: [],
    legend: {
      show: false
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            show: false
          }
        }
      }
    ],
    plotOptions: {
      pie: {
        donut: {
          size: '70%'
        },
      }
    },
    tooltip: {
      fillSeriesColor: false,
    }
  }

  hBarChartOptions: Partial<HBarChartOptions> = {
    series: [
      {
        data: []
      }
    ],
    chart: {
      type: "bar",
      height: 240,
      toolbar: {
        show: true,
        tools: {
          download: false
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true
      }
    },
    dataLabels: {
      enabled: true
    },
    xaxis: {
      categories: ["Roles", "Technologies", "Designations", "Departments"]
    }
  };

  multipleRadialChartOptions: Partial<MultipleRadialChartOptions> = {
    series: [30, 20, 7],
    chart: {
      height: 300,
      type: "radialBar"
    },
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            fontSize: "22px"
          },
          value: {
            fontSize: "16px"
          },
          total: {
            show: true,
            label: "Total"
          }
        },
        hollow: {
          margin: 5,
          size: '45%'
        },
      }
    },
    labels: ["Pending", "Approved", "Rejected"],
  };

  updateBreadcrumb() {
    const breadcrumbs = [
      {
        label: 'page {{pageOneID}}',
        url: '/page1/:pageOneID'
      },
      {
        label: 'page {{pageTwoID}}',
        url: 'page1/:pageOneID/page2/:pageTwoID'
      },
      {
        label: 'page {{pageThreeID}}',
        url: 'page1/:pageOneID/page2/:pageTwoID/page3/:pageThreeID'
      },
      {
        label: 'Update Breadcrumb',
        url: ''
      }
    ];
    this.ngDynamicBreadcrumbService.updateBreadcrumb(breadcrumbs);
  }

  listUser() {
    this.dashboardService.listUser().subscribe((res: any) => {
      if (res['total']) {
        this.countUser = res['total'];
      }
    });
  }

  listClients() {
    this.dashboardService.GetClient().subscribe((res: any) => {
      if (res['total']) {
        this.countclient = res['total'];
      }
    });
  }

  listProjects() {
    this.dashboardService.GetProject().subscribe((res: any) => {
      if (res['total']) {
        this.countProject = res['total'];
      }
    });
  }

  listRole() {
    this.dashboardService.listRole('', this.page - 1, this.rows, 3).subscribe((res: any) => {
      if (res['total'])
        this.countRole = res['total'];
      this.chartArray.push(this.countRole);
    });
  }

  listTechnology() {
    this.dashboardService.listTechnology('', this.page - 1, this.rows, 3).subscribe((res: any) => {
      if (res['total'])
        this.countTechnology = res['total'];
      this.chartArray.push(this.countTechnology);
    });
  }

  listAllDesignation() {
    this.dashboardService.listDesignation('', this.page - 1, this.rows, 3).subscribe((res: any) => {
      if (res['total'])
        this.countDesignation = res['total'];
      this.chartArray.push(this.countDesignation);
    });
  }

  listDepartments() {
    this.dashboardService.listDepartment().subscribe((res: any) => {
      if (res['total'])
        this.countDepartment = res['total'];
      this.chartArray.push(this.countDepartment);
    });
  }

  GetManagementOverview() {
    this.hBarChartOptions.series[0].data = this.chartArray;
    window.dispatchEvent(new Event('resize'))
  }

  getJobId(event) {
    this.jobid = event.iJobId;
    this.ipipelineid = event.iPipelineId;
    this.GetCandidateByStage();
  }

  GetCandidateByStage() {
    this.dashboardService.listCandidateByStage(this.ipipelineid, this.jobid).subscribe((result: any) => {
      if (result['code'] == 200) {
        this.candidateData = [];
        this.candidateByStageArray = result['data'][0]['PipelineStages'];
        this.candidateByStageArray.forEach(element => {
          this.candidateData.push(element);
        });
        this.donutChartOptions.series = [];
        this.donutChartOptions.labels = [];
        this.candidateData.forEach(element => {
          this.donutChartOptions.series.push(element.Candidates.length);
          this.donutChartOptions.labels.push(element.vName);
        });
      }
      window.dispatchEvent(new Event('resize'))
    })
  }

  listAllJobs() {
    this.dashboardService.listJob().subscribe((res: any) => {
      let arr = [];
      if (res['data'].length > 0) {
        res['data'].map((ele) => {
          let data = {
            iJobId: ele.iJobId,
            iPipelineId: ele.Pipeline.iPipelineId,
            vName: ele.vName
          };
          arr.unshift(data);
        })
        this.list = arr;
        this.job = this.list[0];
        this.jobid = this.job.iJobId;
        this.ipipelineid = this.job.iPipelineId;
        this.GetCandidateByStage();
      }
      else {
        this.list = [];
      }
    });
  }

  countUsersByRole() {
    this.dashboardService.countUserByRole().subscribe((res: any) => {
      this.countData = res['data'];
    });
  }

  PrOverview() {
    this.dashboardService.PrOverview().subscribe((res: any) => {
      if (res['code'] == 200) {
        this.prData = [];
        this.prData = res['data'];
        const removeArray = [this.prData[0], this.prData[2], this.prData[5], this.prData[8]];
        var idArray = removeArray.map((user) => user.iPRStatusId);
        this.prData = this.prData.filter((item) => {
          return idArray.indexOf(item.iPRStatusId) === -1;
        });
        this.prData.forEach(element => {
          this.barChartOptions.series[0].data.push(element.usercount);
          this.barChartOptions.xaxis.categories.push(element.vName);
        });
      }
    });
  }

  validateUser(){
    this.dashboardService.validateUser().subscribe((result: any) => {
      console.log(result,'resultttttttttttttt');
      
      this.userRole = result['data'].UserRoles[0].Role.vName;       
    })
  }
}
